<script lang="ts" setup>
/* eslint-disable vue/no-v-html */
import type { QuoteData } from '~/components/quote/Quote.vue'

interface PagesInsuranceDetailIntro {
    data: {
        cta: {
            primary: CTA
            secondary: CTA
        }
        content: string
        persona: QuoteData
    }
}

const props = defineProps<PagesInsuranceDetailIntro>()
const { $t, $formatTableHtml } = useNuxtApp()
const title = $t('Predstavenie poistenia')
</script>
<template>
  <section
    id="uvod"
    class="row"
  >
    <Tracker :data="{ position: title }">
      <div
        class="col-12 mb-12 mb-md-14"
        :class="{ 'col-lg-6': props.data.persona.name }"
        data-cy="insurance_detail_intro_text"
      >
        <Typo>
          <h2 class="gamma">
            {{ title }}
          </h2>

          <div v-html="$formatTableHtml(props.data.content)" />

          <div
            v-if="props.data.cta"
            class="mt-7 d-flex gap-4"
          >
            <VButton
              v-if="props.data.cta.primary.link"
              :to="props.data.cta.primary.link"
              :target="
                props.data.cta.primary.isExternal
                  ? '_blank'
                  : '_self'
              "
              color="primary"
              size="large"
              :label="props.data.cta.primary.text"
            >
              {{ props.data.cta.primary.text }}
            </VButton>
            <VButton
              v-if="props.data.cta.secondary?.link"
              :to="props.data.cta.secondary?.link"
              :target="
                props.data.cta.secondary?.isExternal
                  ? '_blank'
                  : '_self'
              "
              color="secondary"
              size="large"
              :label="props.data.cta.secondary.text"
            >
              {{ props.data.cta.secondary?.text }}
            </VButton>
          </div>
        </Typo>
      </div>
      <div
        v-if="props.data.persona.name"
        class="col-12 col-lg-5 ms-auto mb-10 mb-lg-0"
      >
        <Quote
          :data="props.data.persona"
          description-classes="lead fs-biggest"
        />
      </div>
    </Tracker>
  </section>
</template>
